import { render, staticRenderFns } from "./TextEmbed.vue?vue&type=template&id=2ce464f1&scoped=true&"
import script from "./TextEmbed.vue?vue&type=script&lang=js&"
export * from "./TextEmbed.vue?vue&type=script&lang=js&"
import style0 from "./TextEmbed.vue?vue&type=style&index=0&id=2ce464f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce464f1",
  null
  
)

export default component.exports